<template>
  <a-card :bordered="false" :active="zzz">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="厂外销售播报开关" style="margin-left: 30px">
              <div id="toggle-switch-demo" >
                <toggle-switch :resultData="resultData" :curStyle="curStyle" @changeSwitch="change" v-if="isInit"></toggle-switch>
              </div>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="厂外采购播报开关">
              <div id="toggle-switch-demo1" >
                <toggle-switch :resultData="resultData1" :curStyle="curStyle" @changeSwitch="change" v-if="isInit"></toggle-switch>
              </div>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
     <!-- <h3 :class="data1">销售排队情况</h3>
    <s-table
      :class="data1"
      ref="table1"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.logisticsNo"
      :columns="columns"
      :data="loadData"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
    <span slot="serial" slot-scope="text, record, index">
      {{ index + 1 }}
    </span>
    </s-table>
      <h3 :class="data2">采购排队情况</h3>
    <s-table
      :class="data2"
      ref="table2"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.logisticsNo"
      :columns="columns"
      :data="loadPurchaseData"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
    <span slot="serial" slot-scope="text, record, index">
      {{ index + 1 }}
    </span>
    </s-table>-->

    <a-card class="card" title="厂外销售排队">
      <template>
        <div class="log-div" v-for="(item, i) in sellMaterSelect" :key="item.materielName">
          <div class="log-div-title">{{item.materielName}}</div>
          <div class="log-div-cont">
            <a-table
              :ref="item.materielName"
              size="small"
              :bordered="config.globlaBordered"
              :rowKey="(record, index) => index"
              :columns="columns"
              :dataSource="sellMaterSelect[i]['data']"
              :pagination="false"
            >
              <span slot="serial" slot-scope="text, record, index">
            {{ index + 1 }}
            </span>
            </a-table>

          </div>
        </div>
      </template>
    </a-card>

    <a-card class="card" title="厂外采购排队">
      <template>
        <div class="log-div" v-for="(item, i) in purMaterSelect" :key="item.materielName">
          <div class="log-div-title">{{item.materielName}}</div>
          <div class="log-div-cont">
            <a-table
              :ref="item.materielName"
              size="small"
              :bordered="config.globlaBordered"
              :rowKey="(record, index) => index"
              :columns="columns"
              :dataSource="purMaterSelect[i]['data']"
              :pagination="false"
            >
              <span slot="serial" slot-scope="text, record, index">
            {{ index + 1 }}
            </span>
            </a-table>

          </div>
        </div>
      </template>
    </a-card>
  </a-card>
</template>
<script>
  import { STable } from '@/components'
  import {queueCallPage,queueCallPurchasePage,getCallData,getIp} from '@/api/basic'
  import { blackListSave } from '@/api/basic'
  import { formatDate } from '@/utils/date'
  import moment from 'moment'
  import ToggleSwitch from "vue-multi-toggle-switch";
  import Vue from "vue";
  Vue.use(ToggleSwitch);

  export default {
    name: 'QueueCallList',
    components: {
      STable
    },
    meta: {
      keepAlive: false
    },
    data () {
      return {
        sellMaterSelect:[],
        purMaterSelect:[],
        ipString:'',
        ipSelect: null,
        sellCallData:[],
        resultData: [],
        resultData1: [],
        curStyle: {},
        isInit: false,
        voiceSelect:[],
        voices:[],
       // data1:"hide",
       // data2:"hide",
        zzz: 1,
        pageSizeOptionsList:['10'],
        description: '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
        visible: false,
        accredit: false,
        value:0,
        // 定时器
        _timer: null,
        form: this.$form.createForm(this),
        // 查询参数
        queryParam: {},

        // 表头
        columns: [
          {
            title: '#',
            scopedSlots: { customRender: 'serial' },
            width: '40px',
          },
          {
            title: '车号',
            width: '300px',
            dataIndex: 'vehicleNo'
          },
         /* {
            title: '货物名称',
            width: '300px',
            dataIndex: 'materielName',
          },*/
          {
            title: '卸(装)料口',
            width: '300px',
            dataIndex: 'code',
          }
        ],

        // 加载数据方法 必须为 Promise 对象
       /* loadPurchaseData: parameter => {
          return queueCallPurchasePage(Object.assign(parameter, this.queryParam))
            .then(res => {
              return res.data
            })
        },*/

        // 加载数据方法 必须为 Promise 对象
        /*loadData: parameter => {
          return queueCallPage(Object.assign(parameter, this.queryParam))
            .then(res => {
              return res.data
            })
        },*/
      }
    },
    created () {
      //this.loadIpString();
      this.resultData = [
        {
          id: "456",
          status: false,
          on: "开",
          off: "关"
        }
      ];
      this.resultData1= [
        {
          id: "457",
          status: false,
          on: "开",
          off: "关"
        }
      ];
      this.curStyle = { switch_on: "red" };
      this.isInit = true;
      this.loadSellQueueData();
      this.loadPurQueueData();
    /*  if(!this._timer){
        this.setTimer()
      }
      this.voices = speechSynthesis.getVoices();
      this.loadSellQueueCallData ();*/
    },
    beforeDestroyed(){
    },
    destroyed(){
      clearInterval(this._timer)
      this._timer=null
    },
    methods: {
      moment,
      loadSellQueueCallData () { // 从后台拉去下拉列表数据
        var businessTypeId='';
        if(this.resultData[0].status){
          businessTypeId='101'
        }else{
          businessTypeId='102'
        }
        new Promise(resolve => {
          const data = getCallData({businessTypeId:businessTypeId }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.sellCallData = res
          for(var i=0;i<this.sellCallData.length;i++){
            var temp=this.sellCallData[i];
            var content=temp.toString().replace(/\s/g,"");
            this.sleep(3000)
            this.play(content);
          }
        })
      },
      loadIpString(){
        new Promise(resolve => {
          const data = getIp({}).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.ipString = res
        })
      },
      loadSellQueueData(){
          new Promise(resolve => {
            const data = queueCallPage({}).then(res => {
                return res.data
            })
            resolve(data)
          }).then(res => {
            let transferMap = new Map()
            for (let i = 0; i < res.content.length; i++) {
              if (transferMap[res.content[i].materielName]) {
                let transfer = transferMap[res.content[i].materielName]
                transfer.push(res.content[i])
                transferMap[res.content[i].materielName] = transfer
              } else {
                let transfer = [res.content[i]]
                transferMap[res.content[i].materielName] = transfer
              }
            }

            let list = []
            for(let key in transferMap){
              let map = new Map()
              if (transferMap[key]) {
                map["materielName"] = transferMap[key][0].materielName
                map["data"] = transferMap[key]
                list.push(map)
              }
            }
            this.sellMaterSelect=list
          })
      },
      loadPurQueueData(){
        new Promise(resolve => {
          const data = queueCallPurchasePage({}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          let transferMap = new Map()
          for (let i = 0; i < res.content.length; i++) {
            if (transferMap[res.content[i].materielName]) {
              let transfer = transferMap[res.content[i].materielName]
              transfer.push(res.content[i])
              transferMap[res.content[i].materielName] = transfer
            } else {
              let transfer = [res.content[i]]
              transferMap[res.content[i].materielName] = transfer
            }
          }

          let list = []
          for(let key in transferMap){
            let map = new Map()
            if (transferMap[key]) {
              map["materielName"] = transferMap[key][0].materielName
              map["data"] = transferMap[key]
              list.push(map)
            }
          }
          this.purMaterSelect=list
        })
      },
      change(result) {
        if(result.id=='456'){
            if(this.resultData[0].status) {
             // this.data1='show'
             // this.data2 = 'hide'
            //  this.$refs.table1.refresh()
              this.resultData1= [
                {
                  id: "457",
                  status: false,
                  on: "开",
                  off: "关"
                }
              ];
            }
          this.zzz++
        }else{
            if(this.resultData1[0].status){
            //  this.data1 = 'hide'
            //  this.data2 = 'show'
            //  this.$refs.table2.refresh()
              this.resultData= [
                {
                  id: "456",
                  status: false,
                  on: "开",
                  off: "关"
                }
              ];
            }
            this.zzz++
        }
        //  如果ip符合叫号电脑ip一直开启定时器
       /* var  isTrue=true;
        this.ipSelect = this.$store.getters.codeList.call_ip
        for(var i=0;i<this.ipSelect.length;i++){
          if(this.ipSelect[i].name ==this.ipString){
              isTrue=false;*/
       if(this.resultData[0].status || this.resultData1[0].status) {
         this.voices = speechSynthesis.getVoices();
         this.$message.success('开启定时器叫号功能!')
         if (!this._timer) {
           this.setTimer()
         }
       }else{
         this.$message.success('关闭定时器叫号功能!')
       }
        /*  }
        }*/
        /*if(isTrue){
          this.$message.success('请使用指定电脑叫号!')
        }*/
      },
      sleep(numberMillis) {

        var now = new Date();
        var exitTime = now.getTime() + numberMillis;
        while (true) {
          now = new Date();
          if (now.getTime() > exitTime)
            return;
        }
      },

      play(e) {
        this.cancel();
       var  to_speak = new SpeechSynthesisUtterance(e);
        to_speak.rate = 0.5;// 设置播放语速，范围：0.1 - 10之间
        to_speak.voice = this.voices[0];
        window.speechSynthesis.speak(to_speak);
      },
      pause() {
        window.speechSynthesis.pause();
      },
      resume() {
        window.speechSynthesis.resume(); //继续
      },
      cancel() {
        window.speechSynthesis.cancel();
      },
      init(){
        window.speechSynthesis.getVoices()
      },
      setTimer(){
          if(this._timer == null){
              this._timer =setInterval( () =>{
                this.loadSellQueueCallData ();
                this.$refs.table1.refresh();
                this.$refs.table2.refresh();
              },30000)  // 30000
          }
      },
      get() {
        this.value ++;

      },
      },

  }
</script>
<style>
  .show{
    display:block;
  }
  .hide{
    display: none;
  }
</style>
<style lang="less" scoped>
  .card{
    margin-bottom: 24px;
  }
  .stepbox {
  // border: solid 1px #000;
    width: 25%;
    float: left;
  }
  .steps-content {
    text-align: center;
  // border: solid 1px #090;
    width: 75%;
    float: left;
    border-radius: 5px;
    background-color: rgb(240, 240, 240);
    padding: 0.5%;
    overflow-y: auto;
  }
  .cont-item {
    border: solid 3px #000;
    float: left;
    background: #FFF;
    padding-top: 3px;
    padding-bottom: 3px;
    text-align: center;
  }
  .log-div{
    border: double 2px #bbb;
    width: 23%;
    float: left;
    border-radius: 5px;
    margin: 15px;
  }
  .log-div .log-div-title {
    border-bottom: double 1px #ccc;
    padding: 3px;
    padding-left: 8px;
    text-align: center;
    background-color: #efefef;
  }
  .log-div .log-div-cont>div {
    padding: 3px;
    padding-left: 8px;
    padding-right: 8px;
    height: 200px;
  }
</style>
